module.exports = {
  name: '/test/name',
  pageList:'/company/pageList'
}
